import { render, staticRenderFns } from "./AsignaSedePersonal.vue?vue&type=template&id=21a8ab28"
import script from "./AsignaSedePersonal.vue?vue&type=script&lang=js"
export * from "./AsignaSedePersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports